var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-filtered-search',{attrs:{"placeholder":_vm.__('Filter pipelines'),"available-tokens":_vm.tokens},on:{"submit":_vm.onSubmit},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }